import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';
import { BrowserRouter } from 'react-router-dom';
import { ApiProvider } from './context/ApiContext';
import { NavigationProvider } from './context/NavigationContext';
import { ThemeProvider } from './context/ThemeContext';

// Set the API base URL in window for utility functions that don't have access to React context
if (typeof window !== 'undefined') {
    window.__API_BASE_URL__ = process.env.REACT_APP_API_URL || '';
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ThemeProvider>
        <ApiProvider>
            <BrowserRouter>
                <NavigationProvider>
                    <App />
                </NavigationProvider>
            </BrowserRouter>
        </ApiProvider>
    </ThemeProvider>
);
